"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgGlasses02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.96 4H6a1 1 0 1 1 0 2c-.285 0-.372 0-.44.006a2 2 0 0 0-1.814 1.642 6.783 6.783 0 0 0-.05.437l-.262 2.622a5.002 5.002 0 0 1 7.225 2.475 5.019 5.019 0 0 1 2.682 0 5.002 5.002 0 0 1 7.225-2.475l-.262-2.622a6.73 6.73 0 0 0-.05-.437 2 2 0 0 0-1.815-1.642A6.782 6.782 0 0 0 18 6a1 1 0 1 1 0-2h.04c.228 0 .399 0 .554.012a4 4 0 0 1 3.629 3.284c.027.153.044.323.067.55l.62 6.21a5.031 5.031 0 0 1 .09.96 5 5 0 0 1-9.997.156 3.016 3.016 0 0 0-2.006 0 5 5 0 1 1-9.908-1.115l.618-6.171c0-.014.002-.027.003-.04.023-.227.04-.397.067-.55a4 4 0 0 1 3.63-3.284C5.56 4 5.731 4 5.96 4Z", fill: "currentColor" }) }))); };
exports.default = SvgGlasses02;
